export const CREATOR = 'CREATOR';
export const CUSTOM = 'CUSTOM';
export const USERS_AND_TEAMS = 'USERS_AND_TEAMS';
export const EVERYONE = 'EVERYONE';